export function getTotalsText(pcs, total) {
    if (pcs == null || pcs == 0) return '0'
    let str = `${pcs}pc${pcs===1 ? '' : 's'}`
    if (total != null && total > 0) {
        str += ` / $${total?.toLocaleString(undefined, {maximumFractionDigits: 0})}`
    }
    return str
}